import './shared/fonts.js';
import './styles/main.css';
import './shared/share.css';
import { startGame } from './game.js';

// __APP_VERSION__ is package.json's version, injected at build time (vite.config.js)
document.getElementById('app-version').textContent = `© ${new Date().getFullYear()} 0cog Inc. · v${__APP_VERSION__}`;
startGame();
